import { createFileRoute } from '@tanstack/react-router';

import { DeleteAccountLanding } from 'src/apps/account/app/components/DeleteAccount';

export const Route = createFileRoute(
  '/_auth/(no-layout)/account/delete/landing/app'
)({
  component: () => <DeleteAccountLanding variant="app" />,
});
